import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { CellContext } from '../generics';
import ProductTableCellSecondary from './cell-secondary'; // Needs to be the lowest common factor of all the split counts

import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var ROWS = 6;

var ProductTableCellSplit = function ProductTableCellSplit(_ref) {
  var children = _ref.children;

  var _React$useContext = React.useContext(CellContext),
      gridColumnStart = _React$useContext.gridColumnStart,
      gridColumnSpan = _React$useContext.gridColumnSpan;

  var nonNullChildren = React.Children.toArray(children).filter(function (c) {
    return c;
  });
  var rowsHeight = ROWS / nonNullChildren.length;

  if (nonNullChildren.length === 1) {
    return _jsx(React.Fragment, {
      children: nonNullChildren.map(function (child, _index) {
        return /*#__PURE__*/React.isValidElement(child) && _jsx(ProductTableCellSecondary, _objectSpread({}, child.props), _index);
      })
    });
  } else {
    return _jsx(React.Fragment, {
      children: nonNullChildren.map(function (child, index) {
        return _jsx(CellContext.Provider, {
          value: {
            gridColumnStart: gridColumnStart,
            gridColumnSpan: gridColumnSpan,
            gridRowStart: 4 + index * rowsHeight,
            gridRowSpan: rowsHeight,
            firstInSplit: index === 0,
            inSplit: true
          },
          children: child
        }, index);
      })
    });
  }
};

export default ProductTableCellSplit;
//# sourceMappingURL=cell-split.js.map